// debugger
// console.log('hello from LooxProductReviewsApp customization js file');

const reviewsAppContent = document.querySelector('.loox-rating');
// debugger

// console.log('reviewsAppContent: ', reviewsAppContent);
const pdpLeftSectionWrapperProductTitle = document.querySelector('.left-section-wrapper-info-la > .header-product-la');
// debugger
// console.log('pdpLeftSectionWrapperProductTitle: ', pdpLeftSectionWrapperProductTitle);
const reviewIcons = document.querySelector('.loox-rating-content');

if (reviewIcons) {
  reviewIcons.addEventListener('click', () => {
    const looxApp = document.getElementById('loox-app');
    const looxReviews = document.getElementById('looxReviews');
    const looxGrid = document.getElementById('grid-wrap')
    
    if (looxApp) {
      looxApp.scrollIntoView({ behavior: 'smooth' });
    } else if (looxReviews) {
      looxReviews.scrollIntoView({ behavior: 'smooth' });
    } 
  });
}


// to do, consider to add continus checker while reviewsAppContent will appear (fully rendered) - checked working, think about this if in the future issues will appear
pdpLeftSectionWrapperProductTitle.insertAdjacentElement("afterend", reviewsAppContent);